// biome-ignore-all lint/style/useImportType: Angular DI requires runtime class imports for constructor injection.
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { AuthenticationService } from "@core/services/auth";
import { Role, User } from "@core/models";
import { isCbcSchoolAdmin } from "@core/helpers/cbc-access.helpers";

export interface MobileNavTab {
  label: string;
  routerLink: string;
  icon: "home" | "book" | "clipboard" | "notes" | "subscription" | "question-bank" | "school" | "learn" | "beewiz" | "exams";
}

@Component({
  standalone: false,
  selector: "app-mobile-bottom-nav",
  templateUrl: "./mobile-bottom-nav.component.html",
  styleUrls: ["./mobile-bottom-nav.component.scss"],
})
export class MobileBottomNavComponent implements OnInit, OnDestroy {
  tabs: MobileNavTab[] = [];
  private unsubscribe$ = new Subject<void>();

  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.authenticationService.currentUser
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((user) => {
        this.tabs = this.tabsForRole(user);
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  trackByLink(_: number, tab: MobileNavTab): string {
    return tab.routerLink;
  }

  private tabsForRole(user: User | null): MobileNavTab[] {
    if (!user) return [];
    switch (user.userRole) {
      case Role.Parent:
        return [
          { label: "Dashboard",    routerLink: "/cbc/dashboard/parent", icon: "home" },
          { label: "Subscription", routerLink: "/cbc/dashboard/subscribe", icon: "subscription" },
        ];
      case Role.CbcStudent:
        return [
          { label: "Learn",        routerLink: "/cbc/learn", icon: "learn" },
          { label: "Assignments",  routerLink: "/cbc/assignments/student", icon: "clipboard" },
          { label: "Notes",        routerLink: "/cbc/notes",             icon: "notes" },
          { label: "Subscription", routerLink: "/cbc/dashboard/subscribe", icon: "subscription" },
        ];
      case Role.Student:
      case Role.independentStudent:
        return [
          { label: "Home",        routerLink: "/dashboard",           icon: "learn" },
          { label: "My School",  routerLink: "/assignments/student", icon: "clipboard" },
          { label: "Leaderboard",        routerLink: "/quiz/leaderboard",               icon: "notes" },
          { label: "BeeWiz", routerLink: "/beewiz", icon: "beewiz" },
          { label: "Exams", routerLink: "/exams/achievers", icon: "exams" },
        ];
      case Role.Teacher:
        return [
          { label: "My School",     routerLink: "/dashboard",           icon: "school" },
          { label: "Assignments",   routerLink: "/assignments/teacher", icon: "clipboard" },
          { label: "Question Bank", routerLink: "/exam-practise",       icon: "question-bank" },
          { label: "Notes",         routerLink: "/notes",               icon: "notes" },
        ];
      case Role.Admin:
        if (isCbcSchoolAdmin(user)) {
          return [
            { label: "Dashboard",   routerLink: "/cbc/dashboard/teacher", icon: "school" },
            { label: "My School",   routerLink: "/school",                icon: "home" },
            { label: "Assignments", routerLink: "/cbc/assignments/teacher", icon: "clipboard" },
            { label: "Notes",       routerLink: "/cbc/notes",             icon: "notes" },
          ];
        }
        return [
          { label: "My School",     routerLink: "/dashboard",           icon: "school" },
          { label: "Assignments",   routerLink: "/assignments/teacher", icon: "clipboard" },
          { label: "Question Bank", routerLink: "/exam-practise",       icon: "question-bank" },
          { label: "Notes",         routerLink: "/notes",               icon: "notes" },
        ];
      case Role.CbcTeacher:
        return [
          { label: "Dashboard",     routerLink: "/cbc/dashboard/teacher", icon: "school" },
          { label: "Assignments",   routerLink: "/cbc/assignments/teacher", icon: "clipboard" },
          { label: "Notes",         routerLink: "/cbc/notes",             icon: "notes" },
        ];
      default:
        return [];
    }
  }
}
